<!-- eslint-disable no-underscore-dangle -->
<template>
  <div class="bg-outer" :key="formKey">
    <v-card v-if="capa" class="bg-inner banner">
      <!-- Sem `contain`: o v-img usa cover, preenchendo a faixa inteira e cortando o
           excesso. Com `contain` a imagem cabia inteira mas sobravam faixas vazias
           sempre que a proporção não batia com a caixa (550x180 no desktop, mais
           estreita no celular) — o que acontece com quase toda imagem enviada.
           Consequência: quem manda a capa precisa saber que as bordas podem ser
           cortadas; o assunto tem que estar no centro. -->
      <v-img :src="capa" height="180px"></v-img>
    </v-card>

    <v-card v-if="formulario && formulario.fordatafinalizado" class="bg-inner titulo">
      <div class="titulo-topo">
        <div class="titulo-icone" v-if="icone">
          <v-icon dark large>{{ icone }}</v-icon>
        </div>
        <div class="titulo-texto">
          <v-card-title>
            <b>{{formulario && formulario.fornome}}</b>
          </v-card-title>
          <v-card-subtitle>
            {{formulario && formulario.fordescricao}}
          </v-card-subtitle>
        </div>
      </div>

      <v-card-text v-if="temCabecalho" class="cabecalho">
        <slot name="cabecalho" :dados="cabecalhoExibicao">
          <cabecalho-origem :dados="cabecalhoExibicao" />
        </slot>
      </v-card-text>

      <v-card-text class="subtitulo">
        Este formulário já foi respondido. Obrigado pela sua cooperação.
      </v-card-text>
    </v-card>

    <v-card v-else-if="!vazio" class="bg-inner titulo">
      <div class="titulo-topo">
        <div class="titulo-icone" v-if="icone">
          <v-icon dark large>{{ icone }}</v-icon>
        </div>
        <div class="titulo-texto">
          <v-card-title>
            <b>{{formulario && formulario.fornome}}</b>
          </v-card-title>
          <v-card-subtitle>
            {{formulario && formulario.fordescricao}}
          </v-card-subtitle>
        </div>
      </div>

      <!-- Cabeçalho da origem logo abaixo do título: slot 'cabecalho' (layout livre)
           ou a renderização padrão em duas colunas. -->
      <v-card-text v-if="temCabecalho" class="cabecalho">
        <slot name="cabecalho" :dados="cabecalhoExibicao">
          <cabecalho-origem :dados="cabecalhoExibicao" />
        </slot>
      </v-card-text>

      <v-card-text v-if="enviado" class="subtitulo">
        Seu formulário foi registrado com sucesso.
      </v-card-text>

     <div class="botoes mb-5" v-if="enviado && !concluido">
        <v-btn color="primary" @click="$_setupQuestionario(true)" text>
          Ver respostas
        </v-btn>
      </div>
    </v-card>

    <v-card v-else class="bg-inner titulo">
      <v-card-title>
        <b>Formulário Inválido</b>
      </v-card-title>
      <v-card-subtitle>
        Não foi possível encontrar o formulário solicitado.
      </v-card-subtitle>
    </v-card>

    <div v-if="!enviado && !vazio && !(formulario && formulario.fordatafinalizado)" class="cards">

      <div v-for="(item, index) in exigeForm" :key="index" class="exige-form">
        <card-text v-if="formulario && formulario.forexigenome === 'S'"
          ref="nome"
          :detalhe="{
            foqnome: 'Nome Completo',
            foqdescricao: 'Por favor, informe seu nome e sobrenome',
            foqobrigatorio: 'S',
            fornomepadrao: formulario.fornomepadrao,
            id: 'user'
          }"
        />

        <card-text v-if="formulario && formulario.forexigecpf === 'S'"
          ref="cpf"
          :detalhe="{
            foqnome: 'CPF',
            foqdescricao: 'Por favor, informe seu CPF',
            foqobrigatorio: 'S',
            forcpfpadrao: formulario.forcpfpadrao,
            id: 'user'
          }"
        />
      </div>

      <template v-for="(item, index) in (formulario && formulario.questoes)">
        <!-- foqtipo nulo = título de seção, sem resposta. -->
        <div v-if="!item.foqtipo" :key="item.id" class="bg-inner secao">
          <span class="secao-numero">{{ numeracao[index].replace(/-$/, '') }}</span>
          <span class="secao-nome">{{ (item.foqnome || '').trim() }}</span>
        </div>
        <component
        v-else
        :is="componenteCard(item.foqtipo)"
        :key="item.id"
        :ref="`questao-${index + 1}`"
        :numero="numeracao[index]"
        :detalhe="item"
        >
        </component>
      </template>
      <br/>
      <div class="botoes mb-5">
        <v-btn color="primary" outlined @click="$_enviaFormulario(false)">
          Salvar
        </v-btn>
        <v-btn disabled color="primary" @click="dialogLimpar = true" text>
          Limpar Formulário
        </v-btn>
      </div>
      <div class="botoes">
        <v-btn color="primary" @click="dialogConcluir = true">
          Concluir Formulário
        </v-btn>
      </div>
      <br/>
    </div>

    <v-dialog v-model="dialogLimpar" max-width="400px">
      <v-card class="rounded-lg">
      <v-card-title class="header headline green white--text justify-space-between">
        <div class="header">Limpar formulário?</div>
      </v-card-title>
      <div class="mx-4 my-auto">
        <v-card-text class="font-weight-small text-subtitle-1">
          Isso irá remover todas as respostas das questões, e não poderá ser desfeito.
        </v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn plain class="my-3" @click="dialogLimpar = false;">Voltar</v-btn>
          <v-btn plain class="my-3" @click="$_limpaFormulario">Limpar formulário</v-btn>
        </div>
      </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConcluir" max-width="400px">
      <v-card class="rounded-lg">
      <v-card-title class="header headline green white--text justify-space-between">
        <div class="header">Concluir formulário</div>
      </v-card-title>
      <div class="mx-4 my-auto">
        <v-card-text class="font-weight-small text-subtitle-1">
          Isso irá enviar as respostas do formulário e não poderá ter alterações.
        </v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn plain class="my-3" @click="dialogConcluir = false;">Voltar</v-btn>
          <v-btn plain class="my-3 green--text" @click="$_enviaFormulario(true)">
            Concluir formulário
          </v-btn>
        </div>
      </div>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :timeout="4000" color="error" top>
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import createApi from './services/api';
import errorHandler from './utils/error-handler';
import CabecalhoOrigem from './components/CabecalhoOrigem.vue';
import { componenteCard } from './utils/tipo-card';

export default {
  name: 'Checklist',

  components: {
    CabecalhoOrigem,
  },

  props: {
    // id do formulário a ser aberto
    id: {
      type: [String, Number],
      default: null,
    },
    // 'api' (padrão): HTTP como sempre. 'dexie-first': a prop `api` é um provider do app
    // com find(id) e salvar(dados).
    modo: {
      type: String,
      default: 'api',
      validator: (valor) => ['api', 'dexie-first'].includes(valor),
    },
    // 'api': { baseURL, token }. 'dexie-first': provider do app.
    api: {
      type: Object,
      default: () => ({}),
    },
    // dados da origem para o cabeçalho customizado (ex.: { Placa, Motorista }).
    // É SÓ EXIBIÇÃO: cada chave vira um par rótulo/valor na tela, na ordem recebida.
    cabecalho: {
      type: Object,
      default: null,
    },
    // Usuário logado no app anfitrião (não o motorista/visitante que responde).
    // Encaminhado no salvamento das respostas: a API usa para identificar quem
    // preencheu, em vez do nome/CPF digitados no próprio formulário.
    //
    // Antes isso viajava DENTRO de `cabecalho`, o que misturava dado com exibição -
    // a chave aparecia como um campo do cabeçalho na tela. Continua sendo lido de lá
    // como fallback para não quebrar quem ainda passa assim, mas a prop tem
    // precedência e é o caminho correto.
    useidusuario: {
      type: [String, Number],
      default: null,
    },
    // Ícone mdi exibido ao lado do título (ex.: 'mdi-clipboard-check-outline').
    // Vazio = nenhum ícone é renderizado.
    icone: {
      type: String,
      default: null,
    },
    // Fotos e vídeos feitos pela câmera do card-file também são baixados para o
    // aparelho (mesmo comportamento das câmeras do agrocampo/secador): se o envio
    // falhar, o usuário ainda tem o arquivo na galeria/Downloads.
    copiagaleria: {
      type: Boolean,
      default: true,
    },
  },

  provide() {
    // Objeto reativo (não um valor fixo) para que o CardFile injetado veja
    // a baseURL atualizada se a prop `api` mudar em runtime (ex.: troca de
    // cliente/tenant reaproveitando a mesma instância do componente).
    this.$_provided = {
      baseURL: (this.api && this.api.baseURL) || '',
      copiaGaleria: this.copiagaleria,
    };
    return {
      checklistBaseURL: this.$_provided,
    };
  },

  data() {
    return {
      formulario: null,
      // Mantém CPF e Nome com padrão igual as questões na $refs
      exigeForm: [true],
      formKey: 0,
      enviado: false,
      concluido: false,
      vazio: null,
      capa: null,
      dialogLimpar: false,
      dialogConcluir: false,
      snackbar: { show: false, message: '' },
    };
  },

  computed: {
    temCabecalho() {
      const temDados = Object.keys(this.cabecalhoExibicao).length > 0;
      const temSlot = !!(this.$slots.cabecalho || this.$scopedSlots.cabecalho);
      return temDados || temSlot;
    },

    // Numeração exibida antes do nome, alinhada por índice com `formulario.questoes`:
    // tópico (foqtipo nulo) vira "1-", "2-"...; as perguntas abaixo dele "1-1", "1-2"...
    // e a contagem reinicia a cada tópico. Perguntas antes do primeiro tópico ficam
    // só com o próprio número ("1-", "2-"...).
    numeracao() {
      const questoes = (this.formulario && this.formulario.questoes) || [];
      let topico = 0;
      let pergunta = 0;

      return questoes.map((item) => {
        if (!item.foqtipo) {
          topico += 1;
          pergunta = 0;
          return `${topico}-`;
        }
        pergunta += 1;
        return topico ? `${topico}-${pergunta}` : `${pergunta}-`;
      });
    },

    // O que de fato vai pra tela. Remove `useidusuario` caso o app anfitrião ainda o
    // mande dentro de `cabecalho` (contrato antigo): é dado de identificação, não um
    // campo pra exibir junto de placa/motorista. Valor nulo ou vazio também fica de fora.
    cabecalhoExibicao() {
      if (!this.cabecalho) return {};

      return Object.keys(this.cabecalho).reduce((exibicao, chave) => {
        if (chave === 'useidusuario') return exibicao;
        if ([null, undefined, ''].includes(this.cabecalho[chave])) return exibicao;
        return { ...exibicao, [chave]: this.cabecalho[chave] };
      }, {});
    },

    // Espalhado nos payloads de salvamento (`{ ...this.$_useidusuarioPayload }`) só
    // quando presente, pra não mandar `useidusuario: undefined` pra API à toa.
    // Prop tem precedência; `cabecalho.useidusuario` é o fallback do contrato antigo.
    $_useidusuarioPayload() {
      const valor = this.useidusuario
        ?? (this.cabecalho && this.cabecalho.useidusuario);

      return valor ? { useidusuario: valor } : {};
    },
  },

  methods: {
    // 'card-text-4000' -> 'card-text': o limite fica no foqtipo, o componente é um só.
    componenteCard,

    $_criaApi() {
      if (this.modo === 'dexie-first') {
        this.$_api = this.api || {};
        return;
      }

      this.$_api = createApi(this.api || {});
    },

    $_onError(evento) {
      const message = evento && evento.detail && evento.detail.message;
      this.snackbar = { show: true, message };
      this.$emit('erro', message);
    },

    async $_setupQuestionario(verResposta = false) {
      if (!this.id) {
        this.vazio = true;
        return;
      }
      const formulario = await this.$_api.find(this.id);
      this.vazio = !Object.keys(formulario).length;

      // Reidrata Nome/CPF a partir do cache local (sem custo de requisição),
      // aplicado ANTES de renderizar para os cards montarem já preenchidos.
      if (!this.vazio) {
        const salvo = this.$_identidadeCacheada(this.id);
        if (salvo && salvo.nome && !formulario.fornomepadrao) formulario.fornomepadrao = salvo.nome;
        if (salvo && salvo.cpf && !formulario.forcpfpadrao) formulario.forcpfpadrao = salvo.cpf;
      }

      this.formulario = formulario;

      const baseURL = this.api && this.api.baseURL;
      if (baseURL && this.formulario.fornomeimagem) {
        this.capa = `${baseURL}/formulario/uploads/capa/${this.formulario.fornomeimagem}`;
      }
      if (verResposta && !this.concluido) {
        this.enviado = false;
      }
    },

    // Recupera a identidade (Nome/CPF) cacheada localmente para reexibir no
    // "Ver respostas" sem nova chamada à API. Retorna null se não houver cache.
    $_identidadeCacheada(id) {
      const salvoRaw = localStorage.getItem(`checklist_user_${id}`);
      if (!salvoRaw) return null;
      try {
        return JSON.parse(salvoRaw);
      } catch (e) {
        return null;
      }
    },

    async $_enviaFormulario(conclusao) {
      // Fecha o diálogo já na entrada: daqui pra frente qualquer falha (campo
      // obrigatório, erro de gravação) é reportada no snackbar, que ficaria
      // escondido atrás do diálogo de confirmação aberto.
      this.dialogConcluir = false;

      // eslint-disable-next-line arrow-body-style
      const questoesRespondidas = Object.entries(this.$refs).filter((item) => {
        // Só cards: tipo não registrado vira elemento HTML (sem _data) e ref vazio vira [].
        const card = item[1] && item[1][0];
        if (!card || !card._isVue || !card._props || !card._props.detalhe) return false;

        const valor = item[1][0]._data.value;
        const tipo = item[1][0]._props.detalhe.foqtipo === 'card-file';
        if (tipo && !valor) return {};
        return !!valor && (valor !== null && valor !== '') ? valor : {};
      });

      const subArray = [];
      const respostas = questoesRespondidas.map((el) => {
        const subquestoes = Object.keys(el[1][0].$refs).filter((key) => key.startsWith('subquestao'));
        if (subquestoes.length > 0) {
          // eslint-disable-next-line no-restricted-syntax
          for (const subRef of subquestoes) {
            const { value } = el[1][0].$refs[subRef][0]._data;
            let resposta;
            const tipo = el[1][0].$refs[subRef][0]._props.detalhe.foqtipo;
            if (tipo === 'card-file') resposta = value;
            else if (Array.isArray(value)) resposta = value.filter((item) => !!item);
            else if (!value || value === '') resposta = null;
            else resposta = value;

            subArray.push({
              questaoRef: el[1][0].$refs[subRef],
              subquestao: true,
              resposta,
              obrigatorio: el[1][0].$refs[subRef][0]._props.detalhe.foqobrigatorio,
              questao: el[1][0].$refs[subRef][0]._props.detalhe.id,
            });
          }
        }
        const { value } = el[1][0]._data;
        const tipo = el[1][0]._props.detalhe.foqtipo;
        let resposta;
        if (tipo === 'card-file') resposta = value;
        else if (Array.isArray(value)) resposta = value.filter((item) => !!item);
        else if (!value || value === '') resposta = null;
        else resposta = value;

        return {
          questaoRef: el[0],
          resposta,
          obrigatorio: el[1][0]._props.detalhe.foqobrigatorio,
          questao: el[1][0]._props.detalhe.id,
        };
      });

      respostas.push(...subArray);
      let breakLoop = false;
      respostas.forEach((el) => {
        // VALIDA OBRIGATORIO
        let element;
        if (el && el.subquestao) [element] = el.questaoRef;
        else [element] = this.$refs[el.questaoRef];
        if (((!el.resposta) || (el.resposta.length === 0)) && (!breakLoop) && (el.obrigatorio === 'S')) {
          breakLoop = true;
          element.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.$_alerta();
          errorHandler('Preencha os campos obrigatórios!');

        // VALIDA TAMANHO DO CPF — por quantidade de DÍGITOS, não pelo tamanho da
        // string. O valor pode chegar sem máscara (ex.: reidratado de forcpfpadrao,
        // dígitos crus) mesmo com o input exibindo a máscara aplicada visualmente
        // pelo v-mask; validar só por .length quebrava esse caso (11 < 14).
        } else if (el.questaoRef === 'cpf' && String(el.resposta).replace(/\D/g, '').length < 11) {
          element.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.$_alerta();
          breakLoop = true;
          errorHandler('CPF não pode ser menor que 14 caracteres!');
        }
        if (element && element._data.rules && element.$refs && element.$refs.rules && element.$refs.rules.hasError) {
          element.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.$_alerta();
          breakLoop = true;
          errorHandler('Arquivo Inválido!');
        }
      });

      if (breakLoop) return;

      const dadosuser = respostas.filter((item) => item.questao === 'user');
      const user = {};

      for (let x = 0; x < dadosuser.length; x += 1) respostas.shift();
      dadosuser.forEach((info) => {
        if (info.questaoRef === 'nome') user.nome = { value: info.resposta };
        if (info.questaoRef === 'cpf') user.cpf = { value: info.resposta };
      });

      if (!user.cpf && this.formulario.forcpfpadrao) {
        user.cpf = { value: this.formulario.forcpfpadrao };
      }
      if (!user.nome && this.formulario.fornomepadrao) {
        user.nome = { value: this.formulario.fornomepadrao };
      }

      // Cacheia a identidade para reidratar o Nome/CPF no "Ver respostas"
      // sem custo de requisição (funciona mesmo quando só a identificação foi salva).
      localStorage.setItem(`checklist_user_${this.formulario.id}`, JSON.stringify({
        nome: user.nome ? user.nome.value : null,
        cpf: user.cpf ? user.cpf.value : null,
      }));

      // Dexie-first: o provider grava tudo; insert/update é decidido pela API no envio.
      if (this.modo === 'dexie-first') {
        const gravou = await this.$_gravaLocal(respostas, user, conclusao);
        if (!gravou) return;

        this.enviado = true;
        if (conclusao) {
          this.concluido = true;
          this.$emit('concluido', { id: this.formulario.id });
        }
        return;
      }

      // Busca sempre (não só quando há CPF): 1 formulário = 1 pessoa, então a
      // identificação é localizada pelo próprio formulário. Sem isso, salvar
      // sem CPF sempre criava respostas novas em vez de atualizar as existentes.
      const infoUpdate = await this.$_api.identificado({ id: this.formulario.id });

      const postRespostas = [];
      const putRespostas = [];

      if (infoUpdate && infoUpdate.length > 0) {
        const questaoMap = {};
        const respostasMap = {};

        respostas.forEach(({ questao, resposta }) => {
          respostasMap[questao] = {
            resposta: Array.isArray(resposta) && resposta ? resposta : [resposta],
            questao,
          };
        });

        infoUpdate.forEach((item) => {
          if (!questaoMap[item.idQuestao]) questaoMap[item.idQuestao] = [];
          questaoMap[item.idQuestao].push(item.idResposta);
        });

        // eslint-disable-next-line no-restricted-syntax
        for await (const idQuestao of Object.keys(respostasMap)) {
          const respostasArr = respostasMap[idQuestao] || [];
          const idsExistentes = questaoMap[idQuestao] || [];
          const maxLength = Math.max(respostasArr.resposta.length, idsExistentes.length);

          for (let i = 0; i < maxLength; i += 1) {
            let resposta;
            if (respostasArr.resposta[i] instanceof File) {
              // eslint-disable-next-line no-await-in-loop
              const arquivo = await this.$_fileToBase64(respostasArr.resposta[i]);
              resposta = { ...arquivo };
            } else {
              resposta = respostasArr.resposta[i] != null ? respostasArr.resposta[i] : null;
            }

            if (idsExistentes[i]) {
              putRespostas.push({ resposta, id: idsExistentes[i], questao: idQuestao });
            } else {
              postRespostas.push({ resposta, id: null, questao: idQuestao });
            }
          }
        }

        if (putRespostas.length > 0) {
          const gravou = await this.$_gravaRespostas('update', {
            id: infoUpdate[0].idIdentificacao,
            formulario: this.formulario.id,
            user: JSON.stringify(user),
            data: JSON.stringify(putRespostas),
            ...this.$_useidusuarioPayload,
          });
          if (!gravou) return;
        }
        if (postRespostas.length > 0) {
          const gravou = await this.$_gravaRespostas('insert', {
            formulario: this.formulario.id,
            user: JSON.stringify(user),
            data: JSON.stringify(postRespostas),
            ...this.$_useidusuarioPayload,
          });
          if (!gravou) return;
        }
      } else {
        // Achata: cada resposta vira uma entrada por item (a resposta de card-file
        // é um ARRAY de File — precisa virar 1 entrada por arquivo, senão o array
        // cru de File é enviado como está e a API não grava nada).
        const respostasFinais = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const res of respostas) {
          delete res.questaoRef;
          if (Array.isArray(res.resposta) && res.resposta.some((v) => v instanceof File)) {
            // eslint-disable-next-line no-restricted-syntax
            for (const item of res.resposta) {
              if (item instanceof File) {
                // eslint-disable-next-line no-await-in-loop
                const arquivo = await this.$_fileToBase64(item);
                respostasFinais.push({ ...res, resposta: { ...arquivo } });
              } else if (item != null) {
                respostasFinais.push({ ...res, resposta: item });
              }
            }
          } else if (res.resposta instanceof File) {
            const arquivo = await this.$_fileToBase64(res.resposta);
            respostasFinais.push({ ...res, resposta: { ...arquivo } });
          } else {
            respostasFinais.push(res);
          }
        }

        const gravou = await this.$_gravaRespostas('insert', {
          formulario: this.formulario.id,
          user: JSON.stringify(user),
          data: JSON.stringify(respostasFinais),
          ...this.$_useidusuarioPayload,
        });
        if (!gravou) return;
      }

      if (conclusao) {
        try {
          await this.$_api.concluir({ id: this.formulario.id });
        } catch (err) {
          errorHandler(err.response && err.response.data && err.response.data.message);
          return;
        }
        this.enviado = true;
        this.concluido = true;
        this.$emit('concluido', { id: this.formulario.id });
      }
    },

    // Salva as respostas e devolve se deu certo. A conclusão depende deste retorno:
    // antes cada envio era um `.then()` solto e o bloco de conclusão rodava logo em
    // seguida de qualquer jeito — um POST que falhasse marcava o formulário como
    // finalizado mesmo sem gravar nada, deixando-o fechado e vazio (só dava para
    // reabrir direto no banco, porque a API descarta `null` em update).
    async $_gravaRespostas(tipo, payload) {
      try {
        if (tipo === 'update') await this.$_api.update(payload);
        else await this.$_api.enviar(payload);

        this.enviado = true;
        this.$emit('enviado', { id: this.formulario.id, tipo });
        return true;
      } catch (err) {
        this.enviado = false;
        errorHandler(err.response && err.response.data && err.response.data.message);
        return false;
      }
    },

    // Entrega ao provider uma entrada por valor; arquivos seguem como File (sem base64).
    async $_gravaLocal(respostas, user, conclusao) {
      const lista = [];

      // eslint-disable-next-line no-restricted-syntax
      for (const item of respostas) {
        const { questao, resposta } = item;

        if (Array.isArray(resposta)) {
          // eslint-disable-next-line no-restricted-syntax
          for (const valor of resposta) {
            if (valor !== null && valor !== undefined && valor !== '') {
              lista.push({ questao, resposta: valor });
            }
          }
        } else {
          lista.push({ questao, resposta: resposta ?? null });
        }
      }

      try {
        await this.$_api.salvar({
          formulario: this.formulario.id,
          user,
          respostas: lista,
          useidusuario: this.$_useidusuarioPayload.useidusuario ?? null,
          concluir: !!conclusao,
        });

        this.$emit('enviado', { id: this.formulario.id, tipo: conclusao ? 'conclusao' : 'local' });
        return true;
      } catch (err) {
        errorHandler(err && err.message ? err.message : 'Não foi possível salvar no dispositivo');
        return false;
      }
    },

    async $_fileToBase64(file) {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
      return {
        data: await base64,
        nome: file.name,
        tipo: file.type,
        idform: this.formulario.id,
      };
    },

    $_limpaFormulario() {
      this.formKey += 1;
      this.dialogLimpar = false;
      // eslint-disable-next-line no-restricted-syntax
      for (const index of Object.keys(this.formulario.questoes)) {
        const dadosResposta = this.formulario.questoes[index].resposta[0];
        this.formulario.questoes[index].resposta = [{
          ...dadosResposta,
          forresposta: null,
        }];
      }
      window.scrollTo(0, 0);
    },
  },

  watch: {
    id() {
      this.enviado = false;
      this.concluido = false;
      this.$_setupQuestionario();
    },
    // Recria o client de API e atualiza a baseURL injetada nos cards de arquivo
    // quando a prop `api` muda em runtime (ex.: mesmo componente reaproveitado
    // para outro cliente/tenant, sem desmontar).
    api: {
      deep: true,
      handler() {
        this.$_criaApi();
        this.$_provided.baseURL = (this.api && this.api.baseURL) || '';
        this.$_setupQuestionario();
      },
    },
    copiagaleria(valor) {
      this.$_provided.copiaGaleria = valor;
    },
  },

  created() {
    this.$_criaApi();
    this.$_setupQuestionario();
  },

  mounted() {
    document.addEventListener('checklist:error', this.$_onError);
  },

  beforeDestroy() {
    document.removeEventListener('checklist:error', this.$_onError);
  },
};
</script>

<style scoped>
  .bg-outer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .bg-inner {
    width: 100%;
    max-width: 550px;
    background-color: #ffffff;
    border-radius: 15px;
    margin-top: 25px;
  }
  .titulo {
    border-top: 10px solid #4CAF50;
  }
  /* Tópico: tarja verde (mesma cor dos cabeçalhos da visita técnica/ordem de
     carregamento) com mais respiro acima, para separar os grupos de perguntas. */
  .secao {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 40px;
    padding: 12px 16px;
    border-radius: 10px;
    background-color: #4CAF50;
    color: #ffffff;
    font-size: 1.1rem;
    font-weight: 600;
    letter-spacing: 0.01em;
    box-shadow: 0 2px 4px rgba(46, 125, 50, 0.25);
  }
  .secao-numero {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    padding: 0 6px;
    border-radius: 8px;
    background-color: #ffffff;
    color: #2E7D32;
    font-size: 1rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .secao-nome {
    min-width: 0;
    overflow-wrap: break-word;
    text-transform: uppercase;
  }
  .titulo.titulo >>> .v-card__title {
    font-size: 1.5rem !important;
    /* Vuetify aplica word-break: break-all por padrão no v-card__title,
       o que corta palavras no meio (ex.: "Todos" -> "Todo"/"s"). Aqui
       só permitimos quebra em espaços/hifens, mantendo o fallback de
       overflow-wrap para strings realmente sem espaço (ex.: uma URL longa). */
    word-break: normal !important;
    overflow-wrap: break-word !important;
  }
  .titulo b {
    font-size: 125%;
  }
  .titulo-topo {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .titulo-texto {
    min-width: 0;
  }
  /* Some com o padding lateral padrão do v-card__title/subtitle: quem dá o
     afastamento da borda agora é o .titulo-topo, senão o texto fica longe demais
     do ícone. */
  .titulo-topo >>> .v-card__title,
  .titulo-topo >>> .v-card__subtitle {
    padding-left: 0;
    padding-right: 0;
  }
  .titulo-icone {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    margin-left: 16px;
    border-radius: 12px;
    background-color: #4CAF50;
  }
  /* Separa o cabeçalho do título sem depender de um <v-divider> extra no template. */
  .cabecalho {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    padding-top: 16px;
  }
  .botoes {
    width: 90%;
    max-width: 550px;
    display: flex;
    justify-content: space-between;
  }
  .exige-form {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .cards {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .subtitulo {
    font-size: 105%;
    font-weight: 400;
  }

  @media (max-width: 600px) {
    .bg-inner,
    .botoes {
      width: 100%;
    }
    .bg-outer {
      padding: 0 12px;
      box-sizing: border-box;
    }
  }
</style>
